export var STICKIES = ['10.75rem'];
export var PERIOD_NEST_LEVELS = {
    1: '2rem',
    2: '3rem',
    3: '4rem',
    4: '5rem',
    5: '6rem',
    6: '7rem',
};
export var INDENT_LEVELS = {
    metric: PERIOD_NEST_LEVELS[1],
    lob: PERIOD_NEST_LEVELS[2],
    queue: PERIOD_NEST_LEVELS[3],
    country: PERIOD_NEST_LEVELS[4],
    location: PERIOD_NEST_LEVELS[5],
    supportStaffLocation: PERIOD_NEST_LEVELS[6],
};
export var isOccupancyValue100Percent = function (value) {
    if (value === null || value === undefined)
        return false;
    var numValue = typeof value === 'string' ? Number.parseFloat(value) : value;
    if (Number.isNaN(numValue))
        return false;
    return numValue === 1 || numValue === 100;
};
export var areAllOccupancyValues100Percent = function (occupancy) {
    return occupancy.every(function (value) { return isOccupancyValue100Percent(value); });
};
export var getSeatsRequiredPeak = function (row, start, end) {
    var _a;
    var children;
    if ('countries' in row)
        children = row.countries;
    else if ('locations' in row)
        children = row.locations;
    if (children === null || children === void 0 ? void 0 : children.length) {
        return children.reduce(function (total, child) { return total + getSeatsRequiredPeak(child, start, end); }, 0);
    }
    return ((_a = row.seatsRequired) !== null && _a !== void 0 ? _a : []).slice(start, end).reduce(function (peak, value) {
        var numericValue = Number(value);
        return Number.isFinite(numericValue) ? Math.max(peak, numericValue) : peak;
    }, 0);
};
